import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-categories-form',
  templateUrl: './categories-form.component.html',
})
export class CategoriesFormComponent implements OnInit {
  url: string = 'categories';

  id!: string;

  /*  form = this.fb.group({
    name: ['', [Validators.required]],
    value: ['', [Validators.required]],
    status: [''],
  }); */
  form!: FormGroup;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      code: ['',],
      name: ['', Validators.required],
      value: ['', Validators.required],
      status: [''],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        name: response.name,
        status: response.status,
        value: response.value,
      });
    });
  }

  createData(): void {
    this.form.value.code = this.form.value.name.toLowerCase();
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('categories');
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      });
  }

  updateData(): void {
    this.form.value.code = this.form.value.name.toLowerCase();
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('categories');
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      });
  }
}
